import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Heading, PageContainer, Section } from '../../../shared/ui';
import { appendYowanPreviewQueryIfNeeded } from '../../../app/host/yowanPreviewRouting';

const YowanNotFoundPage = () => {
  const location = useLocation();
  const homeHref = appendYowanPreviewQueryIfNeeded('/', location.search);

  useEffect(() => {
    document.title = 'ページが見つかりません';

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute(
        'content',
        '揺腕法Webサイトの404ページです。URLが誤っているか、ページが移動した可能性があります。',
      );
    }
  }, []);

  return (
    <Section>
      <PageContainer>
        <div style={{ marginTop: '4.5rem' }}>
          <Heading as="h1" align="left">ページが見つかりません</Heading>
          <p style={{ marginTop: '1rem' }}>
            URLが誤っているか、ページが移動した可能性があります。
          </p>
          <p style={{ marginTop: '1.25rem' }}>
            <Link to={homeHref}>ホームへ戻る</Link>
          </p>
        </div>
      </PageContainer>
    </Section>
  );
};

export default YowanNotFoundPage;
